module.exports = __webpack_public_path__ + "static/media/id-card.6cde4ad7.svg";